:host {
  .av-agent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    // direction: var(--av-direction);
    gap: 8px;
  }

  .av-agent-tray {
    color: var(--av-color-tray);
  }

  .av-agent-cid {
    font-size: 10px;
  }

  .av-agent-avatar {
    width: calc(var(--av-font-size) * 2.6667); // 40px;
    height: calc(var(--av-font-size) * 2.6667); // 40px;
    border-radius: calc(var(--av-font-size) * 1.3334); //25px;
  }

  .av-agent-avatar-hold {
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
  }

  .av-agent-spacer {
    width: 15px;
  }

  .av-agent-icon {
    width: calc(var(--av-font-size) * 2); // 30px;
    height: calc(var(--av-font-size) * 2); // 30px;
    padding: calc(var(--av-font-size) * 0.3334); // 5px;
  }

  .av-agent-muted {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 10;
    border-radius: 50%;
    background-color: transparentize($color: black, $amount: 0.5);
  }
}

.av-agent-avatar {
  position: relative;
}
